import { render, staticRenderFns } from "./gb-ant-select-two-cascader.vue?vue&type=template&id=720d941e&scoped=true&"
import script from "./gb-ant-select-two-cascader.vue?vue&type=script&lang=js&"
export * from "./gb-ant-select-two-cascader.vue?vue&type=script&lang=js&"
import style0 from "./gb-ant-select-two-cascader.vue?vue&type=style&index=0&lang=less&"
import style1 from "./gb-ant-select-two-cascader.vue?vue&type=style&index=1&id=720d941e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720d941e",
  null
  
)

export default component.exports